import {FC, useState, useRef, useEffect} from 'react'
import {PageTitle} from '_metronic/layout/core'
import {useNavigate} from 'react-router-dom'
import {wilayahData, timelineData} from '../../helpers/dummyData'
// COMMENTED: AI chatbot feature removed - no longer needed
// import {searchAnswer, getAllCategories, getFaqByCategory, KnowledgeItem} from '../../helpers/panaKnowledgeBase'
// COMMENTED: AI Service - fitur AI dihapus, menggunakan local knowledge base saja
// import {aiService} from '../../../services/ai'
import WhatsAppFloatingButton from '../../components/WhatsAppFloatingButton'
import '../../styles/pejuang.css'

// COMMENTED: ChatMessage interface - no longer needed after removing AI chatbot
// interface ChatMessage {
//   id: number
//   type: 'user' | 'bot'
//   content: string
//   timestamp: Date
//   relatedQuestions?: KnowledgeItem[]
// }

const PanduanPage: FC = () => {
  const navigate = useNavigate()
  // COMMENTED: Chat-related states - no longer needed
  // const [chatMessages, setChatMessages] = useState<ChatMessage[]>([
  //   {
  //     id: 1,
  //     type: 'bot',
  //     content: 'Halo! Saya asisten virtual PANA. Silakan tanyakan apa saja tentang program PANA Alumni Pejuang Digital. Contoh: "Apa syarat menjadi peserta?" atau "Berapa insentif yang diberikan?"',
  //     timestamp: new Date()
  //   }
  // ])
  // const [inputMessage, setInputMessage] = useState('')
  // const [isTyping, setIsTyping] = useState(false)
  // const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  // const chatEndRef = useRef<HTMLDivElement>(null)
  // const categories = getAllCategories()

  // const categories = getAllCategories()

  // COMMENTED: Chat-related functions - no longer needed
  /*
  // Auto scroll ke bawah saat ada pesan baru - DISABLED
  // useEffect(() => {
  //   if (chatMessages.length > 1) {
  //     chatEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  //   }
  // }, [chatMessages.length])

  const handleSendMessage = async () => {
    if (!inputMessage.trim()) return

    const userMessage: ChatMessage = {
      id: Date.now(),
      type: 'user',
      content: inputMessage,
      timestamp: new Date()
    }

    setChatMessages(prev => [...prev, userMessage])
    const currentMessage = inputMessage
    setInputMessage('')
    setIsTyping(true)

    // COMMENTED: AI Service removed - using local knowledge base only
    // try {
    //   // Call AI API
    //   const response = await aiService.chat(currentMessage)
    //   
    //   // Parse response - ambil dari message.content
    //   const aiAnswer = response.message?.content || response.data?.message?.content || 'Maaf, tidak ada respons dari AI.'
    //   
    //   const botResponse: ChatMessage = {
    //     id: Date.now() + 1,
    //     type: 'bot',
    //     content: aiAnswer.replace(/\n/g, '<br/>'),
    //     timestamp: new Date()
    //   }
    //
    //   setChatMessages(prev => [...prev, botResponse])
    // } catch (error) {
    //   console.error('AI API Error:', error)
      
      // Use local knowledge base directly
      const results = searchAnswer(currentMessage)
      
      let botResponse: ChatMessage
      
      if (results.length > 0) {
        const formattedAnswer = results[0].answer.replace(/\n/g, '<br/>')
        botResponse = {
          id: Date.now() + 1,
          type: 'bot',
          content: formattedAnswer,
          timestamp: new Date(),
          relatedQuestions: results.slice(1)
        }
      } else {
        botResponse = {
          id: Date.now() + 1,
          type: 'bot',
          content: 'Maaf, saya tidak menemukan informasi terkait pertanyaan Anda. Silakan coba pertanyaan lain atau hubungi tim kami melalui WhatsApp.',
          timestamp: new Date()
        }
      }

      setChatMessages(prev => [...prev, botResponse])
    // } finally {
      setIsTyping(false)
    // }
  }

  const handleQuickQuestion = async (question: string) => {
    setInputMessage(question)
    
    const userMessage: ChatMessage = {
      id: Date.now(),
      type: 'user',
      content: question,
      timestamp: new Date()
    }
    setChatMessages(prev => [...prev, userMessage])
    setIsTyping(true)
    setInputMessage('')

    // COMMENTED: AI Service removed - using local knowledge base only
    // try {
    //   // Call AI API
    //   const response = await aiService.chat(question)
    //   
    //   const aiAnswer = response.message?.content || response.data?.message?.content || 'Maaf, tidak ada respons dari AI.'
    //   
    //   const botResponse: ChatMessage = {
    //     id: Date.now() + 1,
    //     type: 'bot',
    //     content: aiAnswer.replace(/\n/g, '<br/>'),
    //     timestamp: new Date()
    //   }
    //   
    //   setChatMessages(prev => [...prev, botResponse])
    // } catch (error) {
    //   console.error('AI API Error:', error)
      
      // Use local knowledge base directly
      const results = searchAnswer(question)
      if (results.length > 0) {
        const formattedAnswer = results[0].answer.replace(/\n/g, '<br/>')
        const botResponse: ChatMessage = {
          id: Date.now() + 1,
          type: 'bot',
          content: formattedAnswer,
          timestamp: new Date(),
          relatedQuestions: results.slice(1)
        }
        setChatMessages(prev => [...prev, botResponse])
      } else {
        const botResponse: ChatMessage = {
          id: Date.now() + 1,
          type: 'bot',
          content: 'Maaf, saya tidak menemukan informasi terkait pertanyaan Anda. Silakan hubungi tim kami melalui WhatsApp.',
          timestamp: new Date()
        }
        setChatMessages(prev => [...prev, botResponse])
      }
    // } finally {
      setIsTyping(false)
    // }
  }

  const handleCategoryClick = (category: string) => {
    setSelectedCategory(selectedCategory == category ? null : category)
  }

  // Convert newlines to br tags
  const formatMessage = (content: string) => {
    return content.replace(/\n/g, '<br/>')
  }
  */

  const stats = [
    {icon: 'bi-people-fill', value: '150', label: 'Total Peserta'},
    {icon: 'bi-geo-alt-fill', value: '4', label: 'Kabupaten'},
    {icon: 'bi-building', value: '150', label: 'Sekolah Dasar'},
    {icon: 'bi-calendar-check', value: '12', label: 'Minggu Penugasan'},
  ]

  return (
    <div className='col-md-12'>
      {/* Hero Header */}
      <div className='pejuang-hero text-white mb-5'>
        <div className='d-flex align-items-center mb-3'>
          <div className='rounded-circle bg-white bg-opacity-20 p-3 me-3'>
            <i className='bi bi-book fs-1 text-white'></i>
          </div>
          <div>
            <h2 className='mb-1'>Panduan PANA Pejuang Digital</h2>
            <p className='mb-0 opacity-90'>
              Informasi lengkap tentang program, wilayah penugasan, dan syarat ketentuan
            </p>
          </div>
        </div>
        <div className='row mt-4 pt-3'>
          <div className='col-6 col-md-3'>
            <div className='d-flex align-items-center'>
              <i className='bi bi-check-circle-fill me-2 fs-4'></i>
              <span>Program Resmi</span>
            </div>
          </div>
          <div className='col-6 col-md-3'>
            <div className='d-flex align-items-center'>
              <i className='bi bi-shield-check me-2 fs-4'></i>
              <span>Terverifikasi</span>
            </div>
          </div>
          <div className='col-6 col-md-3 mt-2 mt-md-0'>
            <div className='d-flex align-items-center'>
              <i className='bi bi-award me-2 fs-4'></i>
              <span>LPDP & Kemendikdasmen</span>
            </div>
          </div>
          <div className='col-6 col-md-3 mt-2 mt-md-0'>
            <div className='d-flex align-items-center'>
              <i className='bi bi-calendar-event me-2 fs-4'></i>
              <span>Batch 2026</span>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className='row mb-5'>
        {stats.map((stat, index) => (
          <div key={index} className='col-6 col-md-3 mb-4'>
            <div className='pejuang-stat-card'>
              <div className='stat-icon'>
                <i className={`bi ${stat.icon}`}></i>
              </div>
              <div className='stat-value'>{stat.value}</div>
              <div className='stat-label'>{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Tentang Program */}
      <div className='pejuang-card mb-5'>
        <div className='card-header'>
          <h5 className='mb-0'>
            <i className='bi bi-info-circle'></i>
            Tentang Program
          </h5>
        </div>
        <div className='card-body'>
          <div className='row align-items-center'>
            <div className='col-lg-7'>
              <p className='mb-4 fs-6 text-gray-700' style={{lineHeight: '1.8'}}>
                <strong className='text-dark'>PANA Alumni Pejuang Digital</strong> adalah program kolaborasi antara 
                Kementerian Pendidikan Dasar dan Menengah (Kemendikdasmen) dan Lembaga Pengelola 
                Dana Pendidikan (LPDP) untuk mempercepat digitalisasi pembelajaran di wilayah 3T 
                (Terdepan, Terluar, Tertinggal) dan Daerah Khusus.
              </p>
              <p className='fs-6 text-gray-700' style={{lineHeight: '1.8'}}>
                Alumni LPDP berperan sebagai <strong className='text-dark'>Pejuang Digital</strong> yang akan mendampingi 
                guru-guru Sekolah Dasar selama <strong className='text-dark'>12 minggu</strong> secara intensif untuk 
                meningkatkan kompetensi digital dalam proses pembelajaran.
              </p>
            </div>
            <div className='col-lg-5'>
              <div className='bg-light rounded-3 p-4 mt-4 mt-lg-0'>
                <h6 className='fw-bold text-dark mb-3'>
                  <i className='bi bi-star-fill me-2' style={{color: '#F95E2F'}}></i>
                  Benefit Program
                </h6>
                <ul className='mb-0'>
                  <li className='mb-2'>Insentif bulanan selama penugasan</li>
                  <li className='mb-2'>Akomodasi & transportasi</li>
                  <li className='mb-2'>Sertifikat penghargaan</li>
                  <li className='mb-2'>Networking dengan alumni LPDP</li>
                  <li className='mb-0'>Pengalaman sosial yang bermakna</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detail Wilayah Penugasan */}
      <div className='pejuang-card mb-5'>
        <div className='card-header'>
          <h5 className='mb-0'>
            <i className='bi bi-geo-alt'></i>
            Detail Wilayah Penugasan
          </h5>
        </div>
        <div className='card-body'>
          <p className='text-gray-600 mb-4'>
            Program ini akan dilaksanakan di <strong>4 kabupaten</strong> yang termasuk dalam kategori 
            Daerah 3T dan Daerah Khusus di Indonesia.
          </p>
          <div className='row'>
            {wilayahData.map((wilayah) => (
              <div key={wilayah.id} className='col-md-6 col-lg-3 mb-4'>
                <div className='pejuang-wilayah-card'>
                  <div className='d-flex align-items-center'>
                    <div className='wilayah-icon'>
                      <i className='bi bi-pin-map'></i>
                    </div>
                    <div>
                      <div className='wilayah-name'>{wilayah.kabupaten}</div>
                      <div className='wilayah-province'>{wilayah.provinsi}</div>
                    </div>
                  </div>
                  <div className='wilayah-stats'>
                    <div className='wilayah-stat-item'>
                      <div className='wilayah-stat-value'>{wilayah.jumlahSekolah}</div>
                      <div className='wilayah-stat-label'>Sekolah</div>
                    </div>
                    <div className='wilayah-stat-item'>
                      <div className='wilayah-stat-value'>{wilayah.kecamatan}</div>
                      <div className='wilayah-stat-label'>Kecamatan</div>
                    </div>
                    <div className='wilayah-stat-item'>
                      <div className='wilayah-stat-value'>{wilayah.desa}</div>
                      <div className='wilayah-stat-label'>Desa</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Syarat & Ketentuan */}
      <div className='pejuang-card mb-5'>
        <div className='card-header'>
          <h5 className='mb-0'>
            <i className='bi bi-list-check'></i>
            Syarat & Ketentuan
          </h5>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-lg-6'>
              <h6 className='fw-bold text-dark mb-4 d-flex align-items-center'>
                <span className='rounded-circle p-2 me-2' style={{background: '#FFF3EE'}}>
                  <i className='bi bi-person-check' style={{color: '#F95E2F'}}></i>
                </span>
                Persyaratan Umum
              </h6>
              <ul className='pejuang-checklist'>
                <li>
                  <i className='bi bi-check-circle-fill'></i>
                  <span>Alumni Penerima Beasiswa LPDP</span>
                </li>
                <li>
                  <i className='bi bi-check-circle-fill'></i>
                  <span>Melakukan pemutakhiran profil diri pada portal Talenta</span>
                </li>
                <li>
                  <i className='bi bi-check-circle-fill'></i>
                  <span>Menulis Essay pada aplikasi pendaftaran sesuai dengan Tema yang dipilih</span>
                </li>
                <li>
                  <i className='bi bi-check-circle-fill'></i>
                  <span>Bersedia ditempatkan di seluruh lokasi penugasan yang telah ditentukan</span>
                </li>
              </ul>
            </div>
            <div className='col-lg-6'>
              <h6 className='fw-bold text-dark mb-4 d-flex align-items-center'>
                <span className='rounded-circle p-2 me-2' style={{background: '#FFF3EE'}}>
                  <i className='bi bi-file-earmark-text' style={{color: '#F95E2F'}}></i>
                </span>
                Dokumen yang Diperlukan
              </h6>
              <ul className='pejuang-checklist'>
                <li>
                  <i className='bi bi-file-earmark-pdf'></i>
                  <span>Mengunggah Surat Keterangan Sehat dari dokter Puskesmas atau Rumah Sakit</span>
                </li>
                <li>
                  <i className='bi bi-file-earmark-pdf'></i>
                  <span>Menandatangani surat pernyataan komitmen pada laman pendaftaran</span>
                </li>
                <li>
                  <i className='bi bi-file-earmark-pdf'></i>
                  <span>Bagi peserta yang sedang bekerja wajib mengunggah surat izin atasan yang membidangi SDM dan mengizinkan untuk mengikuti Program PANA dan membebastugaskan pendaftar selama mengikuti Program PANA</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Alur Pendaftaran */}
      <div className='pejuang-card mb-5'>
        <div className='card-header'>
          <h5 className='mb-0'>
            <i className='bi bi-signpost-2'></i>
            Alur Pendaftaran
          </h5>
        </div>
        <div className='card-body py-5'>
          <div className='pejuang-timeline'>
            <div className='pejuang-timeline-horizontal'>
              {timelineData.map((item) => (
                <div key={item.id} className='pejuang-timeline-item'>
                  <div className='pejuang-timeline-badge'>
                    <span>{item.id}</span>
                  </div>
                  <div className='pejuang-timeline-content'>
                    <div className='pejuang-timeline-title'>{item.judul}</div>
                    <div className='pejuang-timeline-date'>{item.tanggal}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* COMMENTED: AI FAQ Chat section - fitur AI chatbot dihapus */}
      {/* {/* AI FAQ Chat *\/ }
      {/* <div className='pejuang-card mb-5'>
        <div className='card-header'>
          <h5 className='mb-0'>
            <i className='bi bi-robot'></i>
            Tanya AI - Asisten Virtual PANA
          </h5>
        </div>
        <div className='card-body p-0'>
          {/* Chat Container *\/ }
          <div 
            className='p-4' 
            style={{
              height: '400px', 
              overflowY: 'auto', 
              background: '#f8f9fa'
            }}
          >
            {chatMessages.map((msg) => (
              <div 
                key={msg.id} 
                className={`d-flex mb-3 ${msg.type === 'user' ? 'justify-content-end' : 'justify-content-start'}`}
              >
                {msg.type === 'bot' && (
                  <div 
                    className='rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0'
                    style={{
                      width: '36px',
                      height: '36px',
                      background: 'linear-gradient(135deg, #F95E2F 0%, #FDC830 100%)'
                    }}
                  >
                    <i className='bi bi-robot text-white'></i>
                  </div>
                )}
                <div 
                  className={`p-3 rounded-3 ${msg.type == 'user' ? 'text-white' : 'bg-white'}`}
                  style={{
                    maxWidth: '75%',
                    background: msg.type == 'user' ? 'linear-gradient(135deg, #F95E2F 0%, #FDC830 100%)' : undefined,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                  }}
                >
                  <div 
                    style={{fontSize: '0.9rem', lineHeight: '1.6'}}
                    dangerouslySetInnerHTML={{__html: msg.content}}
                  />
                  {msg.relatedQuestions && msg.relatedQuestions.length > 0 && (
                    <div className='mt-3 pt-3 border-top'>
                      <small className='text-muted d-block mb-2'>Pertanyaan terkait:</small>
                      {msg.relatedQuestions.map((q) => (
                        <button
                          key={q.id}
                          className='btn btn-sm btn-outline-secondary me-2 mb-2'
                          style={{fontSize: '0.8rem'}}
                          onClick={() => handleQuickQuestion(q.question)}
                        >
                          {q.question}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                {msg.type === 'user' && (
                  <div 
                    className='rounded-circle d-flex align-items-center justify-content-center ms-2 flex-shrink-0'
                    style={{
                      width: '36px',
                      height: '36px',
                      background: '#e9ecef'
                    }}
                  >
                    <i className='bi bi-person text-secondary'></i>
                  </div>
                )}
              </div>
            ))}
            
            {isTyping && (
              <div className='d-flex justify-content-start mb-3'>
                <div 
                  className='rounded-circle d-flex align-items-center justify-content-center me-2'
                  style={{
                    width: '36px',
                    height: '36px',
                    background: 'linear-gradient(135deg, #F95E2F 0%, #FDC830 100%)'
                  }}
                >
                  <i className='bi bi-robot text-white'></i>
                </div>
                <div className='bg-white p-3 rounded-3' style={{boxShadow: '0 2px 8px rgba(0,0,0,0.08)'}}>
                  <div className='typing-indicator'>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>

          {/* Quick Questions *\/ }
          <div className='p-3 border-top bg-white'>
            <small className='text-muted d-block mb-2'>Pertanyaan populer:</small>
            <div className='d-flex flex-wrap gap-2'>
              <button 
                className='btn btn-sm btn-light'
                onClick={() => handleQuickQuestion('Apa syarat menjadi peserta?')}
              >
                Syarat Peserta
              </button>
              <button 
                className='btn btn-sm btn-light'
                onClick={() => handleQuickQuestion('Berapa insentif yang diberikan?')}
              >
                Insentif
              </button>
              <button 
                className='btn btn-sm btn-light'
                onClick={() => handleQuickQuestion('Kapan pendaftaran dibuka?')}
              >
                Jadwal Pendaftaran
              </button>
              <button 
                className='btn btn-sm btn-light'
                onClick={() => handleQuickQuestion('Di mana wilayah penugasan?')}
              >
                Wilayah Penugasan
              </button>
              <button 
                className='btn btn-sm btn-light'
                onClick={() => handleQuickQuestion('Bagaimana proses seleksi?')}
              >
                Proses Seleksi
              </button>
            </div>
          </div>

          {/* Input Area *\/ }
          <div className='p-3 border-top'>
            <div className='input-group'>
              <input
                type='text'
                className='form-control'
                placeholder='Ketik pertanyaan Anda di sini...'
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
              />
              <button 
                className='btn btn-pejuang'
                onClick={handleSendMessage}
                disabled={!inputMessage.trim() || isTyping}
              >
                <i className='bi bi-send'></i>
              </button>
            </div>
          </div>

          {/* Category Browser *\/ }
          <div className='p-3 border-top bg-light'>
            <small className='text-muted d-block mb-2'>Jelajahi berdasarkan kategori:</small>
            <div className='d-flex flex-wrap gap-2 mb-3'>
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`btn btn-sm ${selectedCategory === cat ? 'btn-pejuang' : 'btn-outline-secondary'}`}
                  onClick={() => handleCategoryClick(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
            
            {selectedCategory && (
              <div className='bg-white rounded-3 p-3'>
                <h6 className='fw-bold mb-3' style={{color: '#F95E2F'}}>
                  <i className='bi bi-folder2-open me-2'></i>
                  {selectedCategory}
                </h6>
                {getFaqByCategory(selectedCategory).map((item) => (
                  <div 
                    key={item.id}
                    className='p-2 mb-2 rounded border-start border-3 bg-light'
                    style={{borderColor: '#F95E2F !important', cursor: 'pointer'}}
                    onClick={() => handleQuickQuestion(item.question)}
                  >
                    <div className='fw-semibold' style={{fontSize: '0.9rem'}}>{item.question}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div> */}

      {/* CTA */}
      <div className='pejuang-cta text-white mb-5'>
        <i className='bi bi-rocket-takeoff fs-1 mb-3 d-block'></i>
        <h3>Siap Menjadi Pejuang Digital?</h3>
        <p>Bergabung bersama 150 Alumni LPDP lainnya untuk mempercepat digitalisasi pendidikan di Indonesia!</p>
        <button
          className='btn btn-light fw-bold px-5 py-3'
          style={{color: '#F95E2F', borderRadius: '50px'}}
          onClick={() => navigate('/my-pana')}
        >
          <i className='bi bi-pencil-square me-2'></i>
          Daftar via Aplikasi PANA
        </button>
      </div>
    </div>
  )
}

const Panduan: FC = () => {
  // Get user name from localStorage
  const getUserName = () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v')
      if (authData) {
        const userData = JSON.parse(authData)
        return userData.fullname || userData.first_name || 'Pendaftar'
      }
    } catch (error) {
      console.error('Error parsing user data:', error)
    }
    return 'Pendaftar'
  }

  const userName = getUserName()
  const whatsappMessage = `Halo, saya ${userName} ingin bertanya tentang PANA Alumni Pejuang Digital`

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'PANA', path: '/pana-beranda', isSeparator: false, isActive: false},
          {title: '/', path: '', isSeparator: false, isActive: false},
        ]}
      >
        Panduan
      </PageTitle>
      <PanduanPage />
      <WhatsAppFloatingButton 
        phoneNumber="+62 857-1941-7202" 
        message={whatsappMessage}
      />
    </>
  )
}

export default Panduan
